
export type Config = {
  firebase?: {
    config?: {
      apiKey: string;
      authDomain: string;
      projectId: string;
      storageBucket: string;
      messagingSenderId: string;
      appId: string;
      measurementId: string;
    };
  } | null
}
let config = {
  firebase: null as Config['firebase'],
} satisfies Config;

export function configure(newConfig: Partial<Config>) {
  config = {
    ...config,
    ...newConfig,
  };
}

export function getConfig(): Config {
  return config;
}